import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { KironPlayerComponent } from '../../../alert/kiron-player/kiron-player.component';
import { BettingServiceService } from "../../../../services/betting_service/betting-service.service";
import { CommonServiceService } from '../../../../services/common_service/common-service.service';
import { StmgService } from '../../../../services/state_Management/stmg.service';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../../../components/alert/alert.component';

import {  Subscription } from 'rxjs';
import { interval } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-kiron',
  templateUrl: './kiron.component.html',
  styleUrls: ['./kiron.component.scss'],
})
export class KironComponent implements OnInit {

  next10 = false;
  kironResults:any=[];
  meeting_data:any;
  meeting_details:any=[];
  reload_time:number;

  kironNewData:any;

  KironDGVideoUrl:any;
  KironHRVideoUrl:any;
  is_logged = false;

  meetingPayload={
    country: 'KR',
    date: this.commanService.getCurrentDateTime(),
    filter: 1,
    inplay: false,
    sport: 'VR',
  }

  subscription: Subscription;
  disable_SP_subscription: Subscription;
  videoPopup: HTMLIonModalElement;

  currentSelectedBets: any = null;    // Block Games

  constructor(public modalController:ModalController,public betting_service: BettingServiceService,public translate:TranslateService,
    private commanService: CommonServiceService,private stmgService: StmgService,public alertController: AlertController,) { 

      //refresh when remove all from bet slip modal
      this.disable_SP_subscription = this.commanService.getClickEvent().subscribe(() => {
      //this.ngOnInit();
      // console.log("subcripton trigger");
      // for (let index = 0; index < this.meeting_details.length; index++) {
      //   for (let x = 0; x < this.meeting_details[index].length; x++){
      //     this.meeting_details[index][x].clicked=false;
      //   }
      // }
      // console.log(this.meeting_details);
    })
    }

    mySubscription: Subscription;

   ngOnInit() {

    this.get_kiron_results();
    
    // get Kiron Meetings
    this.kiron_getMeetings();


    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );

    this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {
      if (selectedBets) {
        this.selection = selectedBets;
      }

    });

    // Block Games
    this.stmgService.cast_selectedBets.subscribe(bets => {
      this.currentSelectedBets = bets;
      // console.log('Game - Subscription updated:', bets);
    });
     
  }


  // get Kiron Meetings
  kiron_getMeetings(){
    
    this.betting_service.getMeetingData(this.meetingPayload).subscribe((data:any) =>{
      this.kiron_data(data);
      this.kironGetEventStartTime(data.payload[0].eventLightDTOs);
    },(error)=>{
    
    });

  }

  kiron_data(d:any){
    let kironMeetings_Data = [];
    if (d.status == 'success') {
      if (d.payload.length > 0) {
        for(let i = 0; i < d.payload[0].eventLightDTOs.length ; i++){
          kironMeetings_Data.push(d.payload[0].eventLightDTOs[i])
      } 
        };
        this.getKironsEventByID(kironMeetings_Data);
    }
   
    };


    getKironsEventByID(d:any){

      let kironEventresult = d;

      //console.log(d.length);

      if(d.length >= 1){
        if(d[0].id != undefined){
          kironEventresult[0].selections = [];
          this.betting_service.getEventSelections(d[0].id).subscribe((data) => {
            let tempd = this.filterKironDAta(data);
            kironEventresult[0].selections = tempd;
          },
          (error) => {
            //console.log(error);
          }
        );
        }
      }
      

      if(d.length >= 2){
        if(d[1].id != undefined){
          kironEventresult[1].selections = [];
          this.betting_service.getEventSelections(d[1].id).subscribe((data) => {
            let tempd = this.filterKironDAta(data);
            kironEventresult[1].selections = tempd;
          },
          (error) => {
            //console.log(error);
          }
        );
        }
      }
      

      if(d.length >= 3){
        if(d[2].id != undefined){
          kironEventresult[2].selections = [];
          this.betting_service.getEventSelections(d[2].id).subscribe((data) => {
            let tempd = this.filterKironDAta(data);
            kironEventresult[2].selections = tempd;
          },
          (error) => {
            //console.log(error);
          }
        );
        }
      }
      

      if(d.length >= 4){
        if(d[3].id != undefined){
          kironEventresult[3].selections = [];
          this.betting_service.getEventSelections(d[3].id).subscribe((data) => {
            let tempd = this.filterKironDAta(data);
            kironEventresult[3].selections = tempd;
          },
          (error) => {
            //console.log(error);
          }
        );
        }
      }
      

      if(d.length >= 5){
        if(d[4].id != undefined){
          kironEventresult[4].selections = [];
          this.betting_service.getEventSelections(d[4].id).subscribe((data) => {
            let tempd = this.filterKironDAta(data);
            kironEventresult[4].selections = tempd;
          },
          (error) => {
            //console.log(error);
          }
        );
        }
      }
      

      if(d.length >= 6){
        if(d[5].id != undefined){
          kironEventresult[5].selections = [];
          this.betting_service.getEventSelections(d[5].id).subscribe((data) => {
            let tempd = this.filterKironDAta(data);
            kironEventresult[5].selections = tempd;
          },
          (error) => {
            //console.log(error);
          }
        );
        }
      }
      

      if(d.length >= 7){
        if(d[6].id != undefined){
          kironEventresult[6].selections = [];
          this.betting_service.getEventSelections(d[6].id).subscribe((data) => {
            let tempd = this.filterKironDAta(data);
            kironEventresult[6].selections = tempd;
          },
          (error) => {
            //console.log(error);
          }
        );
        }
      }



      if(d.length >= 8){
        if(d[7].id != undefined){
          kironEventresult[7].selections = [];
          this.betting_service.getEventSelections(d[7].id).subscribe((data) => {
            let tempd = this.filterKironDAta(data);
            kironEventresult[7].selections = tempd;
          },
          (error) => {
            //console.log(error);
          }
        );
        }
      }
      

      if(d.length >= 9){
        if(d[8].id != undefined){
          kironEventresult[8].selections = [];
          this.betting_service.getEventSelections(d[8].id).subscribe((data) => {
            let tempd = this.filterKironDAta(data);
            kironEventresult[8].selections = tempd;
          },
          (error) => {
            //console.log(error);
          }
        );
        }
      }

  

      if(d.length >= 10){
        if(d[9].id != undefined){
          kironEventresult[9].selections = [];
          this.betting_service.getEventSelections(d[9].id).subscribe((data) => {
            let tempd = this.filterKironDAta(data);
            kironEventresult[9].selections = tempd;
          },
          (error) => {
            //console.log(error);
          }
        );
        }
      }

      

      this.kironNewData = kironEventresult
      //console.log(this.kironNewData);

      // setTimeout(()=>{
      //   this.kironGetEventStartTime(this.kironNewData);
      // },10000)


    }

    filterKironDAta(d:any){
      let temp = [];
      for(let i = 0; i < d.length ; i++){
        temp.push(d[i]);
    }
    return temp;
    }

    kironGetEventStartTime(meeting){
      this.betting_service.eventStartTime(meeting[0].id).subscribe((data) => {

        this.kironEventStartTime(data);
     
        },
        (error) => {
          //console.log(error);
        }
      );

    }

    kironEventStartTime(data){

      let time:any;
      
      time = data.timeToStartMillis;
      time = time / 1000;
      time = Math.round(time);


      this.mySubscription = interval(1000).subscribe((x => {
          if(time < 0){
            this.kiron_getMeetings();
            this.mySubscription.unsubscribe();
          }else{

            if (time != 0 || time > 0) {
            
          } else {
            this.kiron_getMeetings();
            this.mySubscription.unsubscribe();
          }
       
          }
        time--;
              
      }));

    }


  //kiron result method
  get_kiron_results(){
    this.betting_service.getKironResult().subscribe(
      (data) => {
        this.kironResults = data;
        this.kironResults=this.kironResults.reverse();
      },
      (error) => {
        //console.log(error);
      }
    );
  }

  
 //open video player
  async open_VideoPoup(dg:any,hr:any){
   const modal = await this.modalController.create({
      component:KironPlayerComponent ,
      cssClass: 'customPopup',
      componentProps:{KironDGVideoUrl:dg,KironHRVideoUrl:hr}
      // componentProps:{KironDGVideoUrl:this.KironDGVideoUrl,KironHRVideoUrl:this.KironHRVideoUrl}

    });
    this.videoPopup=modal;
    modal.onDidDismiss().then(data=>{
      this.videoPopup=null
    })
    return await modal.present();
  }

  //video button click function
  video_clicked() {
    
    if (this.is_logged) {
     // get kiron dg video
      this.betting_service.getKironDGVideoUrl(this.commanService.getToken()).subscribe(
        (data:any) => {

          this.KironDGVideoUrl = data.url;
         
        },
        (error) => {
          //console.log(error);
        }
      );

      //get kiron HR video
      this.betting_service.getKironHRVideoUrl(this.commanService.getToken()).subscribe(
        (data:any) => {
          this.KironHRVideoUrl = data.url;
          if(!this.videoPopup || this.videoPopup==null){
            this.open_VideoPoup(this.KironDGVideoUrl,this.KironHRVideoUrl);
          }
        },
        (error) => {
          //console.log(error);
        }
      );


      // setTimeout(()=>{
      //   this.open_VideoPoup(this.KironDGVideoUrl,this.KironHRVideoUrl);
      // },1000)

      


    }
    else{
      let alertTitle:string;
      let alertDesc:string;
      this.translate.get('ALERTS.LOGTO_VIDEO.TITLE').subscribe((res: string) => {
        alertTitle=res;
      });
      this.translate.get('ALERTS.LOGTO_VIDEO.DESC').subscribe((res: string) => {
        alertDesc=res;
      });
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", alertTitle, alertDesc);
    }

  }


  //stop the loop
  ngOnDestroy() {
    this.mySubscription?.unsubscribe();
    console.log("unsubsccribe")
  }


    selectionType: string = "";
    maxCount: boolean = false;
    //method for SP buttons
    setSPOdd(value: any) {
      this.selectionType = 'SP';
      value.clicked = !value.clicked;
      value.fr_clicked = false;
  
      if (value.clicked == true) {
        this.maxCount = this.checkMaximuSelectionCount();
        if (this.maxCount == false) {
          this.placeBetObj(value, this.selectionType);
        } else {
          value.clicked = false;
          this.showMaxCountAlert();
        }
      } else {
        this.placeBetObj(value, this.selectionType);
      }
  
    }


    selection: any = {
      eventSelections: []
    };
    // checkMaximuSelectionCount() {
    //   let val: boolean;
    //   let selectionArray=this.selection.eventSelections.filter(m=>!m.isKR3)
    //   if(selectionArray.length == 4){
    //     val = true;
    //   } else {
    //     val = false;
    //   }
    //   return val;
    // }

    checkMaximuSelectionCount(): boolean {

      if (!this.selection || !this.selection.eventSelections) {
        return false;
      }

      const selectionArray = this.selection.eventSelections.filter(m => !m?.isKR3);

      return selectionArray.length === 4;
    }


    placeBetObj(d: any, t: string) {

      // Block Games Selections
    if (!this.selection) {
      this.selection = { eventSelections: [] };
    }
    if (!this.selection.eventSelections) {
      this.selection.eventSelections = [];
    }

    // **CHECK if game bets exist**
    if (this.currentSelectedBets && this.currentSelectedBets !== '') {
      console.log('Race - Inside check, currentBets exists');
      
      const isKironGame = this.currentSelectedBets.payload && (this.currentSelectedBets.payload['@rule'] === 'FeedId88BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId86BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId87BettingOptions');
      console.log('Race - isKironGame:', isKironGame);
      
      if (isKironGame && this.currentSelectedBets.payload.eventSelections) {
        const hasGameBets = this.currentSelectedBets.payload.eventSelections.length > 0;
        console.log('Race - hasGameBets:', hasGameBets);
        
        if (hasGameBets) {
          this.showBlockAlert();
          d.clicked = false;
          d.fr_clicked = false;
          return;
        }
      }
    }

      let oddD: any;
      let oddF: any;
      let win: number = 0;
      let place: number = 0;
  
  
      switch (t) {
  
        case 'SP':
          oddF = 'N';
          oddD = 0.0;
          break;
  
        case 'PO':
          oddF = d.priceOdds.priceFraction;
          oddD = 0.0;
          break;
  
        case 'PD':
          oddF = 'N';
          oddD = d.priceOdds.priceDecimal;
          break;
  
      }
  
      let tempObj = {
        id: d.id,
        oddD: oddD,
        oddF: oddF,
        win: win,
        place: place,
        sportType: d.id
      }
  
      if (t == "SP") {
        if (d.clicked == true) {
          this.maxCount = this.checkMaximuSelectionCount();
          let index = -1;
          for (let i = 0; i < this.selection.eventSelections.length; i++) {
  
            if (this.selection.eventSelections[i].id == d.id) {
              index = i;
              //remove old row
              this.selection.eventSelections.splice(index, 1);
              //add new row
              this.selection.eventSelections.push(tempObj);
              break;
            }
  
          }
  
          // add row
          if (index == -1) {
            this.selection.eventSelections.push(tempObj);
          }
  
  
        } else {
          let index = -1;
          for (let i = 0; i < this.selection.eventSelections.length; i++) {
  
            if (this.selection.eventSelections[i].id == d.id) {
              index = i;
              // remove row
              this.selection.eventSelections.splice(index, 1);
              break;
            }
  
          }
        }
  
      }
  
  
  
      if (t == "PO") {
        if (d.fr_clicked == true) {
          this.maxCount = this.checkMaximuSelectionCount();
          let index = -1;
          for (let i = 0; i < this.selection.eventSelections.length; i++) {
            if (this.selection.eventSelections[i].id == d.id) {
              index = i;
              //remove old row 
              this.selection.eventSelections.splice(index, 1);
              //add new row
              this.selection.eventSelections.push(tempObj);
              break;
            }
  
          }
  
          // add row
          if (index == -1) {
            this.selection.eventSelections.push(tempObj);
          }
  
  
        } else {
          let index = -1;
          for (let i = 0; i < this.selection.eventSelections.length; i++) {
            if (this.selection.eventSelections[i].id == d.id) {
              index = i;
              // remove row
              this.selection.eventSelections.splice(index, 1);
              break;
            }
  
          }
        }
      }
  
      //console.log(this.selection);
  
      this.stmgService.updateSelecteBets(this.selection);
    }


    showMaxCountAlert() {
      let alertTitle:string;
      let alertDesc:string;
      this.translate.get('ALERTS.MAX_COUNT.TITLE').subscribe((res: string) => {
        alertTitle=res;
      });
      this.translate.get('ALERTS.MAX_COUNT.DESC').subscribe((res: string) => {
        alertDesc=res;
      });
      let alert = new AlertComponent(this.alertController);
      alert.launchAlert("",alertTitle,alertDesc);
    }

  // Block Slecetion with Games
  showBlockAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.BLOCK_SELECTIONS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.BLOCK_SELECTIONS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

}
